module.exports = __webpack_public_path__ + "assets/img/1_1708_big.18b3bc97.jpg";